import axios from 'axios';

export default {
    pre_insercion_corredor(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_contactos.pre_insercion_ConCorr",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	consulta_poliza(p_email, p_ejecutivo, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.fnc_consultaPoliza",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
			  })
		})
	},

	consulta_contratante(p_email, p_contratante){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.fnc_consultacontratante",
			"p_args_in": JSON.stringify({
				"p_contratante": p_contratante,
				})
		})
	},

	consulta_corredor(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.fnc_consultacorredor",
			"p_args_in": JSON.stringify({
				"p_corredor": p_corredor,
				})
		})
	},
	
	eliminar_ConCorr(p_email, p_usuario,p_idcontacto){
        return axios
        .post('spoc/modppentry', {
            "p_email": p_email,
            "p_metodo": "pkg_sinpp_contactos.eliminar_ConCorr",
            "p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_idcontacto": p_idcontacto
                })
        })
    },

	insertar_ConCorr(p_email, p_usuario, p_codcorredor, p_contacto, p_procesos, p_mail){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.insertar_ConCorr",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_codcorredor": p_codcorredor,
				"p_contacto": p_contacto,
				"p_procesos": p_procesos,
				"p_mail": p_mail
				})
		})
	},

	editar_ConCorr(p_email, p_usuario, p_idcontacto, p_contacto, p_procesos, p_mail){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.editar_ConCorr",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_idcontacto": p_idcontacto,
				"p_contacto": p_contacto,
				"p_procesos": p_procesos,
				"p_mail": p_mail				
			     })
		});
	},

	recuperar_ConCorr(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.recuperar_ConCorr",
			"p_args_in": JSON.stringify({
				"p_corredor": p_corredor
				})
		})
	},

	recuperar_DatConCorr(p_email, p_idcontacto){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.recuperar_DatConCorr",
			"p_args_in": JSON.stringify({
				"p_idcontacto": p_idcontacto
				})
		})
	},

	pre_insercion_CorrPol(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_contactos.pre_insercion_CorrPol",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	recuperar_CorrPol(p_email, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.recuperar_CorrPol",
			"p_args_in": JSON.stringify({
				"p_poliza": p_poliza
				})
		})
	},

	consulta_CorrPol(p_email, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.consulta_CorrPol",
			"p_args_in": JSON.stringify({
				"p_poliza": p_poliza,
				})
		})
	},

	recuperar_DatCorrPol(p_email, p_idcontacto){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.recuperar_DatCorrPol",
			"p_args_in": JSON.stringify({
				"p_idcontacto": p_idcontacto
				})
		})
	},

	editar_CorrPol(p_email, p_usuario, p_idcontacto, p_contacto, p_procesos, p_mail){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.editar_CorrPol",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_idcontacto": p_idcontacto,
				"p_contacto": p_contacto,
				"p_procesos": p_procesos,
				"p_mail": p_mail				
			     })
		});
	},	

	eliminar_CorrPol(p_email, p_usuario,p_idcontacto){
        return axios
        .post('spoc/modppentry', {
            "p_email": p_email,
            "p_metodo": "pkg_sinpp_contactos.eliminar_CorrPol",
            "p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_idcontacto": p_idcontacto
                })
        })
    },
	
	desactivar_Procesos (p_email, p_usuario, p_idcontactos) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_contactos.desactivar_Procesos",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
					"p_idcontactos": p_idcontactos
				  })
			})
	},

}